import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).ready(function () {
    function handleMinutesOverflow(hours, minutes) {
      hours = Number(hours) + Math.floor(minutes / 60);
      minutes = Number(minutes) % 60;

      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes}`;
    }

    $(document).on($.modal.OPEN, '.modal--tracked-time-form', () => {
      $('#tracked_time_duration').inputmask('99:99', {
        placeholder: '00:00',
        showMaskOnHover: false,
        onKeyDown(event) {
          const input = event.currentTarget;
          const value = input.value;
          const key = event.key;

          if (/^\d$/.test(key) && value.length > 4) {
            const selectionStart = input.selectionStart;
            const newValue = `${value.substring(0, selectionStart)}${key}${value.substring(
              selectionStart + 1
            )}`;

            input.value = newValue;
            const newSelectionStart = selectionStart + (selectionStart === 2 ? 2 : 1);
            input.setSelectionRange(newSelectionStart, newSelectionStart);

            event.preventDefault();
          }
        },
      });

      $('#tracked_time_duration').on('blur', function () {
        const [hours, minutes] = $(this).val().split(':');

        if (minutes > 59) {
          if (hours === '99') {
            // handling hours overflow of tracker time
            $(this).val('99:59');
          } else {
            $(this).val(handleMinutesOverflow(hours, minutes));
          }
        }
      });
    });
  });

  $(document).on(
    'click',
    '.h-s-button--create-tracked-time-category, .h-s-button--export-tracked-times-csv',
    (e) => {
      $(e.currentTarget).blur();
    }
  );

  $(document).on('change', '.checkbox--create-invoice-w-tracked-time', (e) => {
    const invoiceTimes = [];
    const $createInvoiceBtn = $('.s-button--create-invoice-w-tracked-time');

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    $('.checkbox--create-invoice-w-tracked-time:checked').each((i, el) => {
      invoiceTimes.push($(el).data('id'));
    });
    if (invoiceTimes.length > 0) {
      $createInvoiceBtn.removeClass('hide');
      if (invoiceTimes.length > 1) {
        $createInvoiceBtn.find('.s-button__text').text(`(${invoiceTimes.length})`);
      } else {
        $createInvoiceBtn.find('.s-button__text').text('');
      }
      const createInvoiceParams = '?ids=' + invoiceTimes.join(',');
      $createInvoiceBtn.attr(
        'href',
        $createInvoiceBtn.attr('href').split('?')[0] + createInvoiceParams
      );
    } else {
      $createInvoiceBtn.addClass('hide');
      $createInvoiceBtn.attr('href', $createInvoiceBtn.attr('href').split('?')[0]);
    }
  });
});
